@if (state.open) {
  <div
    class="__victoria-logs-overlay"
    [class.is-minimized]="overlay.minimized()"
    [class.is-maximized]="overlay.maximized()"
    [style.top.px]="overlay.maximized() ? null : overlay.position()?.top"
    [style.left.px]="overlay.maximized() ? null : overlay.position()?.left"
    [style.width.px]="overlay.maximized() ? null : overlay.position()?.width"
    [style.height.px]="overlay.maximized() ? null : overlay.position()?.height">

    <div class="__overlay-controls">
      <button
        mat-icon-button
        class="__overlay-btn"
        (click)="onMinimize$.next()"
        title="Minimize">
        <mat-icon fontSet="material-icons-outlined">minimize</mat-icon>
      </button>

      @if (overlay.maximized()) {
        @if (onLoggingPage()) {
          <button
            mat-icon-button
            class="__overlay-btn"
            (click)="onUnmaximize$.next()"
            title="Exit fullscreen">
            <mat-icon fontSet="material-icons-outlined">close_fullscreen</mat-icon>
          </button>
        }
      } @else {
        <button
          mat-icon-button
          class="__overlay-btn"
          (click)="onMaximize$.next()"
          title="Fullscreen">
          <mat-icon fontSet="material-icons-outlined">open_in_full</mat-icon>
        </button>
      }

      @if (rawUrl()) {
        <button
          mat-icon-button
          class="__overlay-btn"
          (click)="openInNewTab()"
          title="Open VictoriaLogs UI in new tab">
          <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
        </button>
      }

      <button
        mat-icon-button
        class="__overlay-btn __overlay-btn--close"
        (click)="onClose$.next()"
        title="Close">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>

    @if (loading()) {
      <div class="__loading">
        <mat-icon class="__loading-icon" fontSet="material-icons-outlined">sync</mat-icon>
        <span>Resolving VictoriaLogs URL…</span>
      </div>
    } @else if (sanitizedUrl()) {
      <iframe
        [src]="sanitizedUrl()"
        frameborder="0"
        allow="clipboard-read; clipboard-write">
      </iframe>
    } @else {
      <div class="__loading">
        <mat-icon class="__loading-icon" fontSet="material-icons-outlined">error_outline</mat-icon>
        <span>VictoriaLogs is not available for this project.</span>
      </div>
    }
  </div>
}
